import { STATIC_CUSTOM_COLUMN_KEYS } from '@components/bid_request/details/constants';
import { ImportResultsColumn } from '@components/bid_request/details/types';

/**
 * Create a map of static columns to their index and key
 * @param columns {ImportResultsColumn[]}
 * @returns {Record<string, [number, string]>}
 */
export const createStaticColumnMap = (
  columns: ImportResultsColumn[]
): Record<string, [number, string]> => {
  const map: Record<string, [number, string]> = {};

  columns.forEach((column, index) => {
    const key = column.template_column_key;

    if (key && STATIC_CUSTOM_COLUMN_KEYS.includes(key)) {
      map[key] = [index, key];
    }
  });

  return map;
};
